export default "__VITE_ASSET__b3xLGt5h__"